<div class="form-date-range-picker">
  @if (companyBounds$ | async; as bounds) {
    <app-date-range-selection
      [fromDate]="fromDate"
      [toDate]="toDate"
      [minDate]="bounds.min"
      [maxDate]="bounds.max"
      [presetBar]="presetBar"
      [timeDetails]="timeDetails"
      (dateRangeSelection)="onDateRangeSelection($event)"
    ></app-date-range-selection>
  }
</div>
